<p
  i18n="@@profileView.opportunities.title"
  class="text-subtitle-1 u-marginBottom-16"
>
  Office Hours hosting
</p>
<a
  *ngFor="let opportunity of opportunities"
  class="u-padding-8 bg-color-black--hover-4 u-display-block"
  [routerLink]="[
    '/hub',
    opportunity.owner_group.slug,
    'event',
    opportunity.slug,
  ]"
  [queryParams]="{ group: opportunity.owner_group._id }"
>
  <p class="">{{ opportunity.title }}</p>
  <p
    i18n="@@profileView.opportunities.eventSchedule"
    class="color-grey-300 text-caption"
  >
    {{ opportunity.event_start_date | date: 'fullDate' }} at
    {{ opportunity.event_start_date | date: 'shortTime' }}
  </p>
</a>
<div *ngIf="!isLoading" class="u-padding-0-8">
  <button
    *ngIf="totalCount > visibleOpportunitiesCount"
    i18n="@@profileView.opportunities.seeMore.label"
    class="c-button color-grey-300 u-textDecoration-underline--hover"
    (click)="getMoreOpportunities()"
  >
    See More
  </button>
</div>
